import { css } from '@emotion/react'
import React from 'react'

interface NotificationProps {
  success?: boolean
  successMessage: string | React.ReactNode
}

const Notification = ({ success, successMessage }: NotificationProps) => (
  <div
    css={css`
      div {
        margin: auto;
        margin-top: 32px;
        margin-bottom: 30vh;
        width: 100%;
        max-width: 1440px;
      }
    `}
  >
    {success ? (
      <div>{successMessage}</div>
    ) : (
      <div>Il y a eu une erreur. Veuillez retenter plus tard</div>
    )}
  </div>
)

export default Notification
